<template>
  <div class="email-template-manager">
    <div class="main-heading">
      <h5 class="title">Email Template Manager</h5>
      <p>Customize automated email templates</p>
    </div>

    <EmailTemplateItem v-for="template in templates" :key="template.id" :template="template"
      :isOpen="activeTemplateId === template.id" @toggle="toggleTemplate(template.id)" @save="handleSaveTemplate" />
  </div>
</template>

<script>
import { STATIC_TEMPLATES } from "../../assets/config/constants";
import firebase from "../../assets/config/firebase";
import EmailTemplateItem from "./EmailTemplateItem.vue";

export default {
  components: { EmailTemplateItem },

  data() {
    return {
      activeTemplateId: null,
      templates: []

    };
  },
  mounted() {
    this.fetchEmailTemplates();
  },
  methods: {
    async fetchEmailTemplates() {
      try {
        const dbTemplatesObj = await firebase.getEmailTemplates();
        console.log("Fetched templates from DB:", dbTemplatesObj);

        if (!dbTemplatesObj) {
          this.templates = [...STATIC_TEMPLATES];
          return;
        }

        const dbTemplates = Object.entries(dbTemplatesObj).map(
          ([key, value]) => ({
            ...value,
            dbId: key
          })
        );

        this.templates = this.mergeTemplates(STATIC_TEMPLATES, dbTemplates);
      } catch (error) {
        console.error("Failed to fetch email templates", error);
        this.templates = [...STATIC_TEMPLATES];
      }
    },
    mergeTemplates(staticTemplates, dbTemplates) {
      const staticMap = new Map();

      staticTemplates.forEach(t => {
        staticMap.set(t.title, { ...t });
      });

      dbTemplates.forEach(dbTemplate => {
        if (staticMap.has(dbTemplate.title)) {
          staticMap.set(dbTemplate.title, {
            ...staticMap.get(dbTemplate.title),
            ...dbTemplate,
            id: staticMap.get(dbTemplate.title).id
          });
        } else {
          staticMap.set(dbTemplate.title, dbTemplate);
        }
      });

      return Array.from(staticMap.values());
    },
    toggleTemplate(id) {
      this.activeTemplateId = this.activeTemplateId === id ? null : id;
    },
    async handleSaveTemplate(updatedTemplate) {
      console.log("Saving template:", updatedTemplate);
      try {
        if (updatedTemplate.dbId) {
          await firebase.updateEmailTemplate(updatedTemplate.dbId, updatedTemplate);
        } else {
          const res = await firebase.addEmailTemplate(updatedTemplate);

          updatedTemplate.dbId = res.id;
        }

        this.templates = this.templates.map(t =>
          t.id === updatedTemplate.id ? updatedTemplate : t
        );
        swal("Saved", "Email template saved successfully", "success");
      } catch (error) {
        console.error("Template save failed", error);
      }
    }
  }
};
</script>

<style scoped>
.main-heading {
  display: flex;
  flex-direction: column;
  gap: 8px;

  h5 {
    margin: 0px;
  }

  p {
    font-weight: 600;
    color: #7b7b7b;
  }
}

.email-template-manager {
  max-width: 100%;
  margin: 40px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/EmailTemplate/EmailTemplateManager.vue